// Lazy load the Meme component to avoid circular dependencies
import { Suspense, lazy } from "react";
import {
  selectAuthStatus,
  selectIsAuthenticated,
} from "store/src/slices/auth-slice";

import Loader from "../loader";
import { Navigate } from "react-router-dom";
import useCheckPermissions from "hooks/src/useCheckPermissons";
import { useSelector } from "react-redux";

// Note: We'll need to import usePermissions in the component that uses this
// This is just a generic implementation that can be used in any app

const Meme = lazy(() => import("../meme"));

function ProtectedRoute({
  children,
  requiredPermissions,
  redirectTo = "/",
  admin = true,
}) {
  const authStatus = useSelector(selectAuthStatus);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { canMutate } = useCheckPermissions(requiredPermissions);

  let hasPermission = canMutate;

  if (authStatus === "loading") {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasPermission) {
    // Show the Meme component instead of redirecting
    return (
      <Suspense fallback={<Loader />}>
        <Meme />
      </Suspense>
    );
  }

  return children;
}

export default ProtectedRoute;
